type StringKeyOf<T extends object> = Extract<keyof T, string>;
type ObjectPredicate<T extends object> = (value: T[StringKeyOf<T>], key: StringKeyOf<T>) => boolean;

/**
 * Creates a new object with own enumerable string-keyed properties
 * for which the predicate returns true.
 */
export function pickBy<T extends object>(object: T | null | undefined, predicate: ObjectPredicate<T>): Partial<T> {
    if (!object) {
        return {};
    }

    const result: Partial<T> = {};

    for (const key of Object.keys(object) as Array<StringKeyOf<T>>) {
        const value = object[key];

        if (predicate(value, key)) {
            result[key] = value;
        }
    }

    return result;
}

/**
 * Creates a new object with own enumerable string-keyed properties
 * for which the predicate returns false.
 */
export function omitBy<T extends object>(object: T | null | undefined, predicate: ObjectPredicate<T>): Partial<T> {
    if (!object) {
        return {};
    }

    const result: Partial<T> = {};

    for (const key of Object.keys(object) as Array<StringKeyOf<T>>) {
        const value = object[key];

        if (!predicate(value, key)) {
            result[key] = value;
        }
    }

    return result;
}
